import { JSX } from 'react';

import { LoggerFactory } from '@videoblocks/typescript-logger';

const logger = LoggerFactory.create('ErrorBox');

export interface ErrorBoxProps {
    message?: string;
    onDismiss?: () => void;
    className?: string;
}

// TODO: This component should be moved to the design system

export default function ErrorBox({ message, onDismiss, className = '' }: ErrorBoxProps): JSX.Element | null {
    if (!message) {
        return null;
    }

    const handleDismiss = () => {
        if (onDismiss) {
            try {
                onDismiss();
            } catch (error) {
                logger.error({ error: error }, 'Error in onDismiss handler');
            }
        }
    };

    return (
        <div className={`bg-red-50 p-4 py-6 rounded-sm border-l-8 border-red-600 ${className}`}>
            <div className="flex">
                <div className="flex-shrink-0">
                    <svg className="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 493.636 493.636">
                        <path d="M421.428,72.476C374.868,25.84,312.86,0.104,246.724,0.044C110.792,0.044,0.112,110.624,0,246.548 c-0.068,65.912,25.544,127.944,72.1,174.584c46.564,46.644,108.492,72.46,174.4,72.46h0.58v-0.048 c134.956,0,246.428-110.608,246.556-246.532C493.7,181.12,468,119.124,421.428,72.476z M257.516,377.292 c-2.852,2.856-6.844,4.5-10.904,4.5c-4.052,0-8.044-1.66-10.932-4.516c-2.856-2.864-4.496-6.852-4.492-10.916 c0.004-4.072,1.876-8.044,4.732-10.884c2.884-2.86,7.218-4.511,11.047-4.542c3.992,0.038,7.811,1.689,10.677,4.562 c2.872,2.848,4.46,6.816,4.456,10.884C262.096,370.46,260.404,374.432,257.516,377.292z M262.112,304.692 c-0.008,8.508-6.928,15.404-15.448,15.404c-8.5-0.008-15.42-6.916-15.416-15.432L231.528,135 c0.004-8.484,3.975-15.387,15.488-15.414c4.093,0.021,7.895,1.613,10.78,4.522c2.912,2.916,4.476,6.788,4.472,10.912 L262.112,304.692z" />
                    </svg>
                </div>
                <div className="ml-3 flex-1">
                    <div className="text-sm text-red-600 whitespace-normal leading-6">{message}</div>
                </div>
                {onDismiss && (
                    <button
                        type="button"
                        onClick={handleDismiss}
                        className="ml-3 flex-shrink-0 text-red-600 hover:text-red-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 rounded-md"
                        aria-label="Close error message"
                    >
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fillRule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </button>
                )}
            </div>
        </div>
    );
}
